import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseHttpService } from '../base.httpservice';
import { SILENT_ERRORS } from '../interceptors/httperror.interceptor';
import { BadgeProgress } from '../../models/badge';
import { GamificationResult } from '../../models/gamification';

@Injectable({
	providedIn: 'root'
})
export class BadgesHttpService extends BaseHttpService {
	protected readonly endpoint = this.apiUrl('users');

	constructor(http: HttpClient) {
		super(http);
	}

	getBadges(userId: string): Observable<BadgeProgress[]> {
		return this.http.get<BadgeProgress[]>(`${this.endpoint}/${userId}/badges`);
	}

	// A level-up/badges a result someone else recorded earned the current user; null (204) when there is none.
	// Claiming removes it server-side, so it is shown once.
	claimCelebration(): Observable<GamificationResult | null> {
		return this.http.post<GamificationResult | null>(`${this.endpoint}/me/celebrations/claim`, null, { context: new HttpContext().set(SILENT_ERRORS, true) });
	}
}
